import { render, staticRenderFns } from "./UrgentService.vue?vue&type=template&id=9b30d4c8&scoped=true&"
import script from "./UrgentService.vue?vue&type=script&lang=ts&"
export * from "./UrgentService.vue?vue&type=script&lang=ts&"
import style0 from "./UrgentService.vue?vue&type=style&index=0&id=9b30d4c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b30d4c8",
  null
  
)

export default component.exports